var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Diamond",
    clipPath: "url(#clip0_362_13770)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.48548 9.85889L9.7858 17.6514L6.2704 9.85889H2.48548ZM12.0005 18.9052L16.0901 9.85889H7.91092L12.0005 18.9052ZM6.30556 8.359L8.69602 3.85928H5.62591L2.25112 8.359H6.30554H6.30556ZM14.2152 17.6514L21.5155 9.85889H17.7306L14.2152 17.6514ZM8.00465 8.359H15.9963L13.6059 3.85928H10.3951L8.00465 8.359ZM17.6954 8.359H21.7499L18.3751 3.85928H15.305L17.6954 8.359ZM19.3477 2.66405L23.8474 8.66366C23.9567 8.80429 24.0075 8.96638 23.9997 9.14996C23.9919 9.33354 23.9255 9.49173 23.8005 9.62453L12.5512 21.6238C12.4106 21.78 12.227 21.8581 12.0005 21.8581C11.7739 21.8581 11.5904 21.78 11.4498 21.6238L0.200475 9.62454C0.0754838 9.49173 0.00908203 9.33354 0.00126953 9.14996C-0.00654297 8.96638 0.0442383 8.80429 0.153613 8.66366L4.65332 2.66406C4.79394 2.46094 4.99314 2.35938 5.25094 2.35938H18.7501C19.0078 2.35938 19.2071 2.46092 19.3477 2.66405Z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_362_13770"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.3b13e8f9696be37c7a4d48c9ea350656.svg";
export { ForwardRef as ReactComponent };